import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { SearchEntities } from '../../../common/enums';
import { ServiceBookService } from '../../../services/serviceBook.service';
import { SEARCH_AUTOCOMPLETE, SEARCH_MODULE_NAMESPACE } from '../../../store/search';
import { SERIVCEBOOK_MODULE_NAMESPACE, SERVICEBOOK_GET_SERVICEBOOK } from '../../../store/service-book';
import { IServiceBookDetails } from '../../../store/service-book/service-book-state.store';
import {DateTimeHelper} from '../../../utils/DateTimeHelper.util'

interface IMapPosition { lat: number, lng: number }

const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)
const SearchStore = namespace(SEARCH_MODULE_NAMESPACE);

@Component({
  name:'ServiceBookDetails',
  components: {

  }
})
class ServiceBookDetails extends Vue {


  @ServiceBookStore.Getter isLoading: boolean;
  @ServiceBookStore.Getter currentServiceBook:IServiceBookDetails

  @ServiceBookStore.Action(SERVICEBOOK_GET_SERVICEBOOK)
  storeGetServiceBook: (id:string) => void


  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetEntitySearch: (payload: {
    entity?: SearchEntities | SearchEntities[], query?: string, limit?: number,
    apartment?: number[], block?: number[]
  }) => Promise<any>;

  dtCenter: { lat: number, lng: number };
  dtMarkerPosition: { lat: number | null, lng: number | null };
  dtTransferServiceBookModalVisible:boolean
  dtIsRecording:boolean
  client:any
  clients:any[]
  dtActionOpen:boolean
  ServiceBookService:ServiceBookService

  constructor() {
    super();
    this.dtCenter = {
      lat: 48.864716, lng: 2.349014
    }
    this.dtMarkerPosition = null;
    this.dtTransferServiceBookModalVisible = false
    this.dtIsRecording = false
    this.client = null
    this.clients = []
    this.dtActionOpen = false
    this.ServiceBookService = new ServiceBookService()
  }

  beforeMount()
  {
    const id = this.$route.params.id
    this.storeGetServiceBook(id)
    this.handleGetClients(null)
  }

  parseDate(date:string) {
    return DateTimeHelper.parseDate(date)
  }

  handleTransferModal()
  {
    this.dtTransferServiceBookModalVisible = true
    this.dtActionOpen = false
  }

  handleTransferServiceBook()
  {
    console.log('handleTransferServiceBook', this.client)
    this.ServiceBookService.transferServiceBook(this.$route.params.id, {
      owner_id:this.client
    }).then(reponse=>{
      console.log(reponse)
      this.dtTransferServiceBookModalVisible = false
      this.$router.replace({path:'/service-book'})
    }).catch(error=>{
      console.log(error)
    })
  }

  handleClose()
  {
    console.log('handleClose')
  }

  handleBeforeModalClose()
  {
    console.log('handleBeforeModalClose')
  }

  get coClients() {
    return [...(this.clients || [])];
  }

  async handleGetClients(key: string | null) {
    try {
      const data = await this.storeGetEntitySearch({
        entity: [SearchEntities.ServiceBook],
        query: key,
        limit: 50
      })
      //console.log(data)
      this.clients = data
    } catch (error) {
      console.log(error)
    }
  }

  get name():string {
    if(!this.currentServiceBook.apartment) return '...'
    return this.currentServiceBook.apartment.apartment_number
  }

  get type():string {
    if(!this.currentServiceBook.apartment) return null
    return this.currentServiceBook.apartment.apartment_type.name
  }

  get floor():string {
    if(!this.currentServiceBook.apartment) return null
    if(!this.currentServiceBook.apartment.floor) return null
    return this.currentServiceBook.apartment.floor
  }

  get square_meter():string {
    if(!this.currentServiceBook.apartment) return null
    if(!this.currentServiceBook.apartment.square_meter) return null
    return this.currentServiceBook.apartment.square_meter+'㎡'
  }

  get address():string {
    if(!this.currentServiceBook.address) return null
    const {line1, line2, zip_code, city, country} = this.currentServiceBook.address
    const array = [line1, line2, zip_code, city, country]
    const filtred = array.filter(n => n)
    return filtred.join(', ')
  }

  get duration():string {
    if(!this.currentServiceBook.duration) return null
    return this.currentServiceBook.duration + ' jours'
  }

  get createdAt():string {
    if(!this.currentServiceBook.createdAt) return null
    return this.parseDate(this.currentServiceBook.createdAt)
  }

  get activatedAt():string {
    if(!this.currentServiceBook.activatedAt) return null
    return this.parseDate(this.currentServiceBook.activatedAt)
  }

  get expireAt():string {
    if(!this.currentServiceBook.expireAt) return null
    return this.parseDate(this.currentServiceBook.expireAt)
  }

  get mapPosition():IMapPosition {
    const {address} = this.currentServiceBook
    if(!address) return {lat: 48.864716, lng: 2.349014}
    const {lat, lng} = address
    if(!lat || !lng) return {lat: 48.864716, lng: 2.349014}
    return {lat:Number(lat),lng:Number(lng)}

  }


}

export default ServiceBookDetails;



// WEBPACK FOOTER //
// ./src/containers/service-book/details/index.ts